import { AuditCard } from "@/pages/a7/Audit/AuditCard";
import i18n from "@/i18n";
import { useParams } from "react-router-dom";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { EditCardWrapper } from "@/features/Edit/EditCardWrapper.tsx";
import { a7FIAInstrumentTSEditForm } from "@/pages/a7/EditForms/a7FIAInstrumentTSEditForm.tsx";
import { getInstrumentTsAuditColumns } from "./columns";

const table_name = "a7_fia_instrument_ts";

export const A7FIAInstrumentTSEdit = () => {
  const { id } = useParams<{ id: string }>();
  const { t, i18n: i18nClient } = useTranslation(["tables", "common"]);
  const auditColumns = useMemo(
    () => getInstrumentTsAuditColumns(t),
    [t, i18nClient.language],
  );

  if (!id) {
    return <div>{i18n.t("errors.invalid_id")}</div>;
  }

  return (
    <div className="h-full bg-gray-50">
      <div className="flex flex-col gap-10 p-10">
        <div className="flex justify-center">
          <EditCardWrapper
            client={"a7"}
            id={Number(id)}
            headerText={t(`${table_name}.title`, {
              ns: "tables",
              defaultValue: "Financial instrument time series",
            })}
            {...a7FIAInstrumentTSEditForm}
            disable_translations_request={true}
          />
        </div>
        <AuditCard
          client={"a7"}
          id={Number(id)}
          name={table_name}
          audit_columns={auditColumns}
        />
      </div>
    </div>
  );
};
